import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faHourglassHalf, faEyeSlash, faHeadset, faExclamationTriangle, faChartPie, faLightbulb, faPhoneVolume, faClock, faWarning, faUserAltSlash, faDatabase } from '@fortawesome/free-solid-svg-icons';
import '../../styles/logistic/LogisticPainSection.css';
import warehouse from "../../assets/app/Logistic/warehouse-logistics.png";
import { useTranslation, Trans } from "react-i18next";

const LogisticPainSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="logistic-pain-section">
      <div className="logistic-container">
        <div className="logistic-section-image-header">
          <img src={warehouse} alt={t('LogisticPainSection:alt_text')} />
        </div>
        <div className="logistic-section-header">
          <span className="logistic-section-tag">{t('LogisticPainSection:section_tag')}</span>
          <h2>
            <Trans t={t} i18nKey="LogisticPainSection:title">
              Cada Llamada Sin Responder es un <span className="logistic-text-danger">Cliente Perdido</span>
            </Trans>
          </h2>
          <p>{t('LogisticPainSection:subtitle')}</p>
        </div>
        <div className="logistic-pain-grid">
          <div className="logistic-pain-card">
            <div className="logistic-pain-icon danger">
              <FontAwesomeIcon icon={faPhoneVolume} />
            </div>
            <h3>{t('LogisticPainSection:card1_title')}</h3>
            <p>{t('LogisticPainSection:card1_text')}</p>
            <span className="logistic-pain-cost">{t('LogisticPainSection:card1_cost')}</span>
          </div>
          <div className="logistic-pain-card">
            <div className="logistic-pain-icon danger">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <h3>{t('LogisticPainSection:card2_title')}</h3>
            <p>{t('LogisticPainSection:card2_text')}</p>
            <span className="logistic-pain-cost">{t('LogisticPainSection:card2_cost')}</span>
          </div>
          <div className="logistic-pain-card">
            <div className="logistic-pain-icon danger">
              <FontAwesomeIcon icon={faWarning} />
            </div>
            <h3>{t('LogisticPainSection:card3_title')}</h3>
            <p>{t('LogisticPainSection:card3_text')}</p>
            <span className="logistic-pain-cost">{t('LogisticPainSection:card3_cost')}</span>
          </div>
          <div className="logistic-pain-card">
            <div className="logistic-pain-icon danger">
              <FontAwesomeIcon icon={faUserAltSlash} />
            </div>
            <h3>{t('LogisticPainSection:card4_title')}</h3>
            <p>{t('LogisticPainSection:card4_text')}</p>
            <span className="logistic-pain-cost">{t('LogisticPainSection:card4_cost')}</span>
          </div>
          <div className="logistic-pain-card">
            <div className="logistic-pain-icon danger">
              <FontAwesomeIcon icon={faDatabase} />
            </div>
            <h3>{t('LogisticPainSection:card5_title')}</h3>
            <p>{t('LogisticPainSection:card5_text')}</p>
            <span className="logistic-pain-cost">{t('LogisticPainSection:card5_cost')}</span>
          </div>
          <div className="logistic-pain-card">
            <div className="logistic-pain-icon danger">
              <FontAwesomeIcon icon={faDollarSign} />
            </div>
            <h3>{t('LogisticPainSection:card6_title')}</h3>
            <p>{t('LogisticPainSection:card6_text')}</p>
            <span className="logistic-pain-cost">{t('LogisticPainSection:card6_cost')}</span>
          </div>
        </div>
        <div className="logistic-reality-check">
          <div className="logistic-reality-content">
            <div className="logistic-reality-icon">
              <FontAwesomeIcon icon={faLightbulb} />
            </div>
            <div>
              <h3>{t('LogisticPainSection:reality_check_title')}</h3>
              <p>{t('LogisticPainSection:reality_check_text')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticPainSection;